import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
	CompetenceElementaireSESSAD,
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { User } from 'src/app/shared/models/security/user';
import { Prestation, PrestationStatutString, StatutBeneficiaireString } from 'src/app/shared/models/prestation';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PrestationModalAjoutComponent } from '../modal/prestation-modal-ajout/prestation-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { PrestationTypeString } from 'src/app/shared/models/prestation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { State } from 'src/app/shared/enums/state.enum';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-prestation',
	templateUrl: './list-prestation.component.html',
	styleUrls: ['./list-prestation.component.scss']
})
export class ListInfosasComponent implements OnInit {
	LABEL_INTERVENANT: string;
	LABEL_INTERVENANT_CAPITALIZED;
	LABEL_INTERVENANT_PLURIALIZED: string;

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationStatutStringEnum = PrestationStatutString;
	public StatutBeneficiaireStringEnum = StatutBeneficiaireString;
	prestations: Prestation[] = [];
	currentPage = 0;

	prestationCsvFile: File = null;

	dismissible: true;
	alerts: any[] = [];
	user: User = null;

	isAddable = true;
	isImportable = true;
	isExportable = true;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	selectedIntervenants: string[] = [];
	searchedText: string;

	listIntervenants: Employee[];
	listSelectedIntervenant: Employee[] = [];

	ajoutIntervenantModalref: BsModalRef;

	itemsPerPage = 10;

	isMobile = false;
	screenWidth: number;

	isListingLoading: boolean = true;

	prestationTypeString = PrestationTypeString;

	/**
	 * Etat de la mission
	 */
	state = State;


	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		console.log(this.StatutBeneficiaireStringEnum);
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.LABEL_INTERVENANT_CAPITALIZED =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.LABEL_INTERVENANT_PLURIALIZED =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENANT
			);

		this.user = this.facade.dataStorageService.getUser();

		this.getPrestations();
	}

	getPrestations(): void {
		this.isListingLoading = true;
		this.facade.infosasService.getAllInfosas().subscribe({
			next: (prestations: Prestation[]) => {
				this.prestations = prestations;
				console.log(this.prestations);
				//this.listIntervenants = this.getPrestationsIntervenants(this.prestations);
				this.currentPage = 1;
				this.itemsPerPage = this.prestations.length >= 5 ? 10 : 5;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
			}
		});
	}


	selectPrestation(prestation: Prestation): void {
		const link = ['/prestation', prestation.id];
		this.router.navigate(link);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		const initialState = {};
		this.ajoutIntervenantModalref = this.modalService.show(
			PrestationModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutIntervenantModalref.onHide.subscribe((reason: string | any) => {
			this.getPrestations();
		});
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	updateSelectedIntervenant(e: any, spe: Employee) {
		if (e.target.checked) {
			if (!this.listSelectedIntervenant.some((e) => e.id === spe.id)) {
				this.listSelectedIntervenant = [...this.listSelectedIntervenant];
				this.listSelectedIntervenant.push(spe);
			}
		} else {
			if (this.listSelectedIntervenant.some((e) => e.id === spe.id)) {
				this.listSelectedIntervenant = this.listSelectedIntervenant.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}


}
